export const WIDGET_THEME_NAMES = [
    "classic",
    "modern",
    "minimal",
    "sharp",
    "soft",
    "couture",
    "terminal",
    "pop",
    "blueprint",
    "paper",
];
function isWidgetThemeName(value) {
    return WIDGET_THEME_NAMES.some((name) => name === value);
}
export function resolveThemeName(value) {
    if (value !== undefined && isWidgetThemeName(value))
        return value;
    return "classic";
}
//# sourceMappingURL=themeNames.js.map